window.$ = window.jQuery = require('jquery');
window.AOS = require('aos');

